import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Link from 'next/link';
import { isLight, shadeColor } from 'flaivy-react';
// import './ImageTileLinks.scss';

function ImageTileLinks({ layout }) {
  const { tiles } = layout;
  return (
    <Container className="pb-3 pb-sm-6">
      <Row>
        {tiles.map((tile, index) => {
          let key = index;
          if (key > 5) key %= 4;
          const bigTile = key % 3 === 0 || key % 4 === 0;
          const tileColor = _.get(tile, 'color', '#fff');
          const darkerColor = shadeColor(
            tileColor,
            isLight(tileColor) ? -50 : 80,
          );

          const darkestColor = shadeColor(
            darkerColor,
            isLight(tileColor) ? -40 : 70,
          );
          return (
            <Col
              xs={6}
              lg={bigTile ? 7 : 5}
              className="mb-2 px-1"
              key={tile.id}
            >
              <Link href={`/${tile.link}`} className="text-decoration-none">
                <div
                  style={{
                    backgroundColor: tileColor,
                    height: '40vw',
                    maxHeight: '300px',
                    opacity: '0.95',
                  }}
                  className="banner banner-tile"
                >
                  <div className="banner-text banner-text-custom text-dark mt-4">
                    <p
                      style={{
                        color: _.get(tile, 'subheadingColor', darkerColor),
                      }}
                      className="subtitle text-xs"
                    >
                      {_.get(tile, 'subheading')}
                    </p>
                    <h2
                      style={{
                        color: _.get(tile, 'headingColor', darkestColor),
                      }}
                      className="mb-0"
                    >
                      {_.get(tile, 'heading')}
                    </h2>
                  </div>

                  <div className="banner-bg banner-tile-image d-none d-md-block">
                    {tile.image && (
                      <img
                        alt={_.get(tile, 'name')}
                        src={tile.image}
                        height="200"
                      />
                    )}
                  </div>
                </div>
              </Link>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}
ImageTileLinks.propTypes = {
  layout: PropTypes.object.isRequired,
};
export default ImageTileLinks;
